import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { Bar } from 'react-chartjs-2';
import CardContent from '@material-ui/core/CardContent';
import PropTypes from 'prop-types';
import 'chartjs-plugin-labels';
import './styles.scss';
import { Skeleton } from '@material-ui/lab';

export default function ScoreGraph(props) {
  const graphData = props.graphData;

  const generateGraph = () => {
    const graph = [];
    (props.isFetching ? [1, 1, 1, 1] : graphData).map((item, index) => {
      const state = props.isFetching
        ? {}
        : {
            labels: ['Scores'],
            datasets: [
              {
                label: `Your Score - ${item.Score}%`,
                data: [item.Score],
                backgroundColor: '#41E5C0',
              },
              {
                label: `Average Score - ${item.AvgScore}%`,
                data: [item.AvgScore],
                backgroundColor: '#984DFF',
              },
              {
                label: `Highest Score - ${item.HighestScore}%`,
                data: [item.HighestScore],
                backgroundColor: '#3498DB',
              },
            ],
          };
      graph.push(
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card className="card graph-cards">
            <CardContent>
              <div className="graph-headings">
                {props.isFetching ? (
                  <Skeleton width="110px" />
                ) : item.SubjectTitle === 'Total' ? (
                  'TOTAL RELATIVE COMPARISON'
                ) : (
                  item.SubjectTitle
                )}
              </div>
              <div className="chart-container">
                {props.isFetching ? (
                  <Skeleton width="320px" height="300px" />
                ) : (
                  item.Score > 0 &&
                  item.AvgScore > 0 &&
                  item.HighestScore > 0 && (
                    <Bar
                      data={state}
                      options={{
                        maintainAspectRatio: false,
                        responsive: true,
                        legend: {
                          display: true,
                          position: 'bottom',
                          align: 'start',
                          labels: {
                            boxWidth: 15,
                          },
                        },
                        plugins: {
                          labels: false,
                        },
                        scales: {
                          xAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                color: 'rgba(0, 0, 0, 0.03)',
                              },
                            },
                          ],
                        },
                        tooltips: {
                          enabled: true,
                          callbacks: {
                            label: function (tooltipItems) {
                              return tooltipItems.yLabel + '%';
                            },
                          },
                        },
                      }}
                    />
                  )
                )}
              </div>
            </CardContent>
          </Card>
        </Grid>
      );
    });
    return graph;
  };
  return (
    <Grid container spacing={2} className="graph-cards-container">
      {generateGraph()}
    </Grid>
  );
}
ScoreGraph.propTypes = {
  graphData: PropTypes.array,
  isFetching: PropTypes.bool,
};
